export default "__VITE_ASSET__BQVcr5Ub__"